import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Spinner } from "react-bootstrap";
import { getSavedContracts } from "../../../service/workflow-api";
import { Breadcrumb, Card, Alert, ListGroup } from "react-bootstrap";
import modalStyles from "../modal-styles";

// SavedContracts Component - Displays all saved contracts in a dedicated view
const SavedContracts = ({ onDelete, onLoad, onView, onBack }) => {

    const [savedContracts, setSavedContracts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      setLoading(true);

      getSavedContracts()
        .then((data) => {
          setSavedContracts(data);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching saved contracts:", error);
          setLoading(false);
        });
    }, []);

    return (
      <>
        <Breadcrumb className="dark-breadcrumb mb-4" style={{ color: "white" }}>
          <Breadcrumb.Item href="/ai-workflows">AI Workflows</Breadcrumb.Item>
          <Breadcrumb.Item href="/ai-workflows/ai-contract-maker">Contract Generator</Breadcrumb.Item>
          <Breadcrumb.Item active>Saved Contracts</Breadcrumb.Item>
        </Breadcrumb>
  
        <Container fluid className="budget-planner-container py-4 min-vh-100">
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card className="dark-main-card text-light mb-4">
                <Card.Body className="p-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <Card.Title as="h2" style={{ fontWeight: 400, color: '#d9d9d9' }}>
                      Saved Contracts
                    </Card.Title>
                    <Button 
                      variant="outline-primary"
                      className="dark-outline-button"
                      onClick={onBack}
                    >
                      Back to Contract Generator
                    </Button>
                  </div>
                  {
                    loading && (
                      <div className="text-center">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    )
                  }
                  {!loading && savedContracts.length === 0 ? (
                    <Alert variant="info" className="dark-alert">
                      No saved contracts found. Create and save a contract to see it here.
                    </Alert>
                  ) : (
                    <ListGroup variant="flush" className="dark-list-group">
                      {savedContracts.map((contract) => (
                        <ListGroup.Item 
                          key={contract.id} 
                          className="dark-list-item d-flex justify-content-between align-items-center mb-3 p-3"
                          style={modalStyles.darkListItem}
                        >
                          <div>
                            <h5 className="mb-1 text-primary">{contract.name}</h5>
                            <p className="mb-1 small" style={{ color: '#ffffff' }}>
                              Type: {contract.contract_type.replace(/-/g, ' ')}
                            </p>
                            <p className="mb-1 small" style={{ color: '#ffffff' }}>
                              Role: {contract.role}
                            </p>
                            <p className="mb-1 small" style={{ color: '#ffffff' }}>
                              Created: {new Date(contract.created_at).toLocaleString()}
                            </p>
                          </div>
                          <div className="d-flex">
                            <Button 
                              variant="outline-primary" 
                              size="sm" 
                              className="me-2 dark-outline-button"
                              onClick={() => onView(contract)}
                            >
                              View
                            </Button>
                            <Button 
                              variant="outline-primary" 
                              size="sm" 
                              className="me-2 dark-outline-button"
                              onClick={() => onLoad(contract)}
                            >
                              Load
                            </Button>
                            <Button 
                              variant="outline-danger" 
                              size="sm"
                              className="dark-outline-button"
                              onClick={() => onDelete(contract.id)}
                            >
                              Delete
                            </Button>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  };

  export default SavedContracts;
